import { validateTechniqueDefinition } from "@ninja/domain";
import type { TechniqueDefinition } from "./TechniqueDefinition.js";
import { ilusaoDoMedo } from "./ilusao_do_medo.js";
import { impactoFrontal } from "./impacto_frontal.js";
import { laminaDeVento } from "./lamina_de_vento.js";
import { palmaRestauradora } from "./palma_restauradora.js";
import { quedaDoTrovao } from "./queda_do_trovao.js";
import { campoDeRelampagos } from "./campo_de_relampagos.js";
import { seloDeProximidade } from "./selo_de_proximidade.js";
import { seloExplosivo } from "./selo_explosivo.js";
import { barreiraRestauradora } from "./barreira_restauradora.js";
import { defesaReflexa } from "./defesa_reflexa.js";
import { contraGolpePreciso } from "./contra_golpe_preciso.js";
import { dominioDasRaizes } from "./dominio_das_raizes.js";
import { seloDemolidor } from "./selo_demolidor.js";
import { seloInstavel } from "./selo_instavel.js";
import { rupturaDasRaizes } from "./ruptura_das_raizes.js";
import { pulsoDeEmergencia } from "./pulso_de_emergencia.js";

const techniqueDefinitions = {
  impacto_frontal: impactoFrontal,
  lamina_de_vento: laminaDeVento,
  selo_explosivo: seloExplosivo,
  palma_restauradora: palmaRestauradora,
  ilusao_do_medo: ilusaoDoMedo,
  queda_do_trovao: quedaDoTrovao,
  campo_de_relampagos: campoDeRelampagos,
  selo_de_proximidade: seloDeProximidade,
  barreira_restauradora: barreiraRestauradora,
  defesa_reflexa: defesaReflexa,
  contra_golpe_preciso: contraGolpePreciso,
  dominio_das_raizes: dominioDasRaizes,
  selo_demolidor: seloDemolidor,
  selo_instavel: seloInstavel,
  ruptura_das_raizes: rupturaDasRaizes,
  pulso_de_emergencia: pulsoDeEmergencia,
} satisfies Record<string, TechniqueDefinition>;

const proficiencyByFamily = {
  taijutsu: "taijutsu",
  elemental_ninjutsu: "ninjutsu",
  fuinjutsu: "ninjutsu",
  medical_ninjutsu: "ninjutsu",
  genjutsu: "genjutsu",
} satisfies Record<
  TechniqueDefinition["family"],
  TechniqueDefinition["proficiency"]
>;

for (const [id, definition] of Object.entries(techniqueDefinitions)) {
  if (id !== definition.id) {
    throw new Error(
      `Technique catalog key ${id} does not match definition id ${definition.id}.`,
    );
  }
  if (definition.proficiency !== proficiencyByFamily[definition.family]) {
    throw new Error(
      `Technique ${id} family ${definition.family} must use ${proficiencyByFamily[definition.family]} proficiency.`,
    );
  }
  validateTechniqueDefinition(definition);
}

export const TECHNIQUES: Record<string, TechniqueDefinition> =
  techniqueDefinitions;
